/**
 * Created by Rumyantsev Daniil on 20.03.2018.
 */
import { Pipe, PipeTransform } from '@angular/core';
import {DateService} from '../_service/date.service';
/*
 * Трансформирует дату в месяц словами и год
 *
 * Usage:
 *   date | monthNameDate
 * Example:
 *   {{ date | monthNameDate }}
 *   formats to: март 2018.
 */
@Pipe({name: 'monthNameDate'})
export class MonthNameDate implements PipeTransform {

  constructor(private dateService: DateService ){}

  transform(date: Date, prefix?: string, needYear: boolean=true): string {
    if(date == null) {
      return "";
    }
   return (prefix || '') + ' ' + this.dateService.getMonthNameDate(date, needYear);
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/month-name-date.pipe.ts